import { ActionsEnum } from '../enum/actions-enum';
import { Mensagem } from '../../models/mensagem';
const initialState = {
	message:  new  Mensagem()
};
export const messageReducer = (state = initialState, action) => {
	if (action.type === ActionsEnum.UPDATE_MESSAGE) {
		return {
			...state,
			message: action.message
		};
	} else {
		return state;
	}
};
